import { useEffect, useState } from "react";
import { toast } from "sonner";
import { WifiOff, RefreshCw } from "lucide-react";
import { getPending, onPendingChange, syncPending } from "@/lib/offline";

export default function OfflineBanner() {
  const [online, setOnline] = useState(navigator.onLine);
  const [pending, setPending] = useState(getPending().length);

  useEffect(() => {
    const run = async () => {
      const n = await syncPending();
      if (n > 0) toast.success(`Synced ${n} offline check-in${n > 1 ? "s" : ""} ✅`);
    };
    const up = () => { setOnline(true); run(); };
    const down = () => setOnline(false);
    window.addEventListener("online", up);
    window.addEventListener("offline", down);
    const off = onPendingChange(() => setPending(getPending().length));
    run();
    const id = setInterval(run, 30000);
    return () => { window.removeEventListener("online", up); window.removeEventListener("offline", down); off(); clearInterval(id); };
  }, []);

  if (online && pending === 0) return null;
  return (
    <div className="mb-6 rounded-2xl px-4 py-3 flex items-center gap-3 text-sm font-semibold text-white mm-fade-up" data-testid="offline-banner"
      style={{ background: online ? "var(--mm-secondary)" : "var(--mm-warning)" }}>
      {online ? <RefreshCw size={16} className="animate-spin" /> : <WifiOff size={16} />}
      <span data-testid="offline-banner-text">
        {online ? `${pending} check-in${pending > 1 ? "s" : ""} syncing…` : `You're offline — check-ins will save on this device and sync when you're back${pending ? ` (${pending} waiting)` : ""}`}
      </span>
    </div>
  );
}
